import { Action, GlobalSearchInitialState } from "../interface";

export const initialState: GlobalSearchInitialState = {
    searchTerm: "",
    searchLoading: false,
    searchRequestId: "",
    searchResults: {
        products: {
            totalResults: 0,
            ids: [],
            results: []
        },
        receiving: {
            totalResults: 0,
            ids: [],
            results: []
        }
    }
};

export const handleUpdateSearchTerm = (state: GlobalSearchInitialState, action: Action) => {
    state.searchTerm = action.payload;
};

export const handleUpdateSearchLoading = (state: GlobalSearchInitialState, action: Action) => {
    state.searchLoading = action.payload;
};

export const handlePendingForFetchSearchResults = (state: GlobalSearchInitialState, action: any) => {
    state.searchRequestId = action.meta.requestId;
    state.searchLoading = true;
};

export const handleRejectForFetchSearchResults = (state: GlobalSearchInitialState) => {
    state.searchResults = initialState.searchResults;
    state.searchLoading = false;
};

export const handleFullfilledForFetchSearchResults = (state: GlobalSearchInitialState, action: any) => {
    if (action.meta.requestId !== state.searchRequestId) {
        return state;
    }
    const { data } = action.payload;
    updateProductsDataForSearch(state, data);
    updateReceivingDataForSearch(state, data);
    state.searchLoading = false;
};

export const formatProductDataForSearch = (products: any) => products?.map((product: any) => ({
    id: product.id,
    name: product.name,
    upc: product?.upcOrType ?? product.upc,
    highlights: product.highlights
})) ?? [];

export const updateProductsDataForSearch = (state: GlobalSearchInitialState, data: any) => {
    const products =
        data?.find((result: any) => result.categoryName === "Products") || {};
    state.searchResults.products.totalResults = products?.totalCount ?? 0;
    state.searchResults.products.ids = products?.ids ?? [];
    state.searchResults.products.results = formatProductDataForSearch(products?.data);
};

export const formatReceivingDataForSearch = (receiving: any) => receiving?.map((__receiving: any) => ({
    id: __receiving.id,
    name: __receiving.name,
    highlights: __receiving.highlights,
    type: __receiving?.upcOrType,
    internalId: __receiving?.internalId ?? ""
})) ?? [];

export const updateReceivingDataForSearch = (state: GlobalSearchInitialState, data: any) => {
    const receiving =
        data?.find((result: any) => result.categoryName === "Receiving") || {};
    state.searchResults.receiving.totalResults = receiving?.totalCount ?? 0;
    state.searchResults.receiving.ids = receiving?.ids ?? [];
    state.searchResults.receiving.results = formatReceivingDataForSearch(receiving?.data);
};
